import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function fetchCommonTemplateList(params) {
  return request({
    url: `${v2Host}/gmaker/template/list`,
    method: 'get',
    params,
  })
}

export function gmakerSubscribe(data) {
  return request({
    url: `${v2Host}/gmaker/subscribe`,
    method: 'post',
    data,
  })
}

// 模板玩法标签
export function gmakerTemplateOptions(params) {
  return request({
    url: `${v2Host}/gmaker/template/options`,
    method: 'get',
    params,
  })
}
